import { Component, OnDestroy, OnInit } from '@angular/core';
import { ServiceDeliveryLocationsFacade } from '../../services/service-delivery-locations.facade';
import { CompanySummary } from '../../models/company-summary';
import { AuthenticationService } from '../../authenticationModule/services/authentication.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseClientComponent } from '../base-client.component';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-service-delivery-locations-shell',
  templateUrl: './service-delivery-locations-shell.component.html',
  styleUrls: ['./service-delivery-locations-shell.component.scss']
})
export class ServiceDeliveryLocationsShellComponent extends BaseClientComponent implements OnInit, OnDestroy {
  companies: CompanySummary[] = [];
  companyOptions: SelectItem[] = [];
  selectedCompany: CompanySummary | null = null;
  selectedCompanyId: number | null = null;
  loadingCompanies = false;
  errorMessage: string | null = null;
  isMckayUser = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly facade: ServiceDeliveryLocationsFacade,
    private readonly authenticationService: AuthenticationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.facade.resetState();
    this.isMckayUser = this.authenticationService.userCurrent.permissions.isMckayUser;

    this.facade.companies$
      .pipe(takeUntil(this.destroy$))
      .subscribe(companies => {
        this.companies = companies;
        this.companyOptions = companies.map(company => ({
          label: company.name,
          value: company.id
        }));
        const currentId = this.selectedCompany?.id;
        const stillExists = currentId ? companies.some(company => company.id === currentId) : false;
        if (!stillExists) {
          this.selectedCompanyId = null;
          this.facade.clearSelection();
        }
        if (!this.isMckayUser && companies.length && !this.selectedCompany) {
          this.facade.selectCompany(companies[0]);
        }
      });

    this.facade.selectedCompany$
      .pipe(takeUntil(this.destroy$))
      .subscribe(company => {
        this.selectedCompany = company;
        this.selectedCompanyId = company?.id ?? null;
      });

    this.facade.companiesLoading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(loading => this.loadingCompanies = loading);

    this.facade.errorMessage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(message => this.errorMessage = message);

    this.facade.loadCompanies();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCompanyChange(companyId: number | null): void {
    if (companyId == null) {
      this.facade.clearSelection();
      return;
    }
    const company = this.companies.find(c => c.id === companyId);
    if (company) {
      this.facade.selectCompany(company);
    }
  }
}
